export default "<img src=\"{{imagePath}}\" alt=\"\" class=\"custom\" (click)=\"close()\">"